import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Home from "./Home";
import Login from "./Login";
import Admin from "./Admin";
import Error from "./Error";
import Roleredirect from "./Roleredirect";
import User from "./user/user";
import Finansije from "./Finansije";
import Services from "./home/services";
import About from "./home/about";
import Contact from "./home/contact";

// Layouts
import MainLayout from "./layouts/MainLayout";
import BlankLayout from "./layouts/BlankLayout";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function App() {
  const [currentLang, setCurrentLang] = useState("sr");
  const { i18n } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    setCurrentLang(lang);
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Layout sa Navbar i Footer */}
        <Route
          element={<MainLayout currentLang={currentLang} changeLang={changeLang} />} >
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Layout bez Navbar i Footer */}
        <Route element={<BlankLayout />}>

          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/error" element={<Error />} />
          <Route path="/user" element={<User />} />
          <Route path="/roleredirect" element={<Roleredirect />} />
          <Route path="/finansije" element={<Finansije />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;